import React from "react";
import { HexColorPicker } from "react-colorful";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";
import HexCodeInput from "./HexCodeInput";
import { cn } from "../../utils/classMerger";

// The one colour picker every screen opens: the react-colorful area picker plus
// HexCodeInput. The caller supplies the trigger (a swatch, a card, an overlay).

interface HexColorPopoverProps {
    color: string;
    onChange: (hex: string) => void;
    /** The trigger element; rendered as-is, so pass one button-like node. */
    children: React.ReactElement;
    align?: "start" | "center" | "end";
    className?: string;
}

const HexColorPopover: React.FC<HexColorPopoverProps> = ({
    color,
    onChange,
    children,
    align = "start",
    className,
}) => (
    <Popover>
        <PopoverTrigger asChild>{children}</PopoverTrigger>
        <PopoverContent
            align={align}
            sideOffset={6}
            className={cn("w-[200px] p-2 space-y-2", className)}
        >
            <HexColorPicker
                color={color}
                onChange={onChange}
                style={{ width: "100%", height: 140 }}
            />
            <div className="flex items-center gap-1.5">
                <span className="text-[10px] font-semibold text-neutral-500">
                    HEX
                </span>
                <HexCodeInput
                    color={color}
                    onChange={onChange}
                    aria-label="Hex colour code"
                    className="flex h-7 w-full rounded-md border border-input bg-white px-2 text-xs shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                />
            </div>
        </PopoverContent>
    </Popover>
);

export default HexColorPopover;
